module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("equalizer")]), _vm._v("\n        " + _vm._s(_vm.$t('reports')) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedReport),
      expression: "selectedReport"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedReport = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("בחר דוח")]), _vm._v(" "), _vm._l((_vm.reports), function(rpt) {
    return _c('option', {
      domProps: {
        "value": rpt
      }
    }, [_vm._v(_vm._s(rpt))])
  })], 2)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), (_vm.rptProjects) ? _c('ReportProjects') : _vm._e(), _vm._v(" "), (_vm.rptCustomers) ? _c('ReportCustomers') : _vm._e(), _vm._v(" "), (_vm.rptDiaries) ? _c('ReportDiaries') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fac3a7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports.vue
// module id = 870
// module chunks = 2